import { gql } from '@apollo/client';

export const VALIDATE_USER = gql`
  query validateUser($input: ValidateUserInput!) {
    validateUser(input: $input)
  }
`;
